export default __webpack_public_path__ + "static/media/39_mobile.e8d16559.jpeg";